import { WorkTimeEntryBreak } from 'record-it-time-common/entity/entities/WorkTimeEntry/WorkTimeEntryDto';
import { DateInput, DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { WorkUtils } from 'record-it-utils/worktime/WorkUtils';
import { WorkTimeEntry } from './workTimeEntryTypes';
export class WorkTimeEntryUtils {
  private constructor() {}
  private static workUtils = new WorkUtils(DateUtils.withCurrentTimezone());
  public static getWorkTimeEntriesDurationSum(workTimeEntries: Array<WorkTimeEntry>): number {
    return workTimeEntries.reduce((sum, entry) => {
      return sum + this.getWorkTimeEntryDuration(entry);
    }, 0);
  }
  public static getWorkTimeEntryDuration(workTimeEntry: WorkTimeEntry): number {
    return this.getDuration(workTimeEntry.startDate, workTimeEntry.endDate, workTimeEntry.breaks);
  }
  public static getDuration(startDate: DateInput, endDate: DateInput, breaks: Array<WorkTimeEntryBreak>): number {
    return this.workUtils.getWorkDurationInMin({
      start: new Date(startDate),
      end: new Date(endDate),
      breaks: breaks.map(b => ({
        start: new Date(b.startDate),
        end: new Date(b.endDate)
      }))
    }) * 60 * 1000;
  }
  public static getWorkTimeEntryBreakDuration(workTimeEntry: WorkTimeEntry): number {
    return this.getBreakDuration(workTimeEntry.breaks);
  }
  public static getBreakDuration(breaks: Array<WorkTimeEntryBreak>): number {
    return breaks.map(b => this.workUtils.getBreakDurationInMin({
      start: new Date(b.startDate),
      end: new Date(b.endDate)
    }) * 60 * 1000).reduce((prev, cur) => prev + cur, 0);
  }
}